import React from "react";
import "../styles/main.css";

class Footer extends React.Component {
  render() {
    return (
      <div>
        <p className="text-experience text-center">
          copyright © 2020 Academia Geek - Agile Innova
        </p>
      </div>
    );
  }
}

export default Footer;
